import { getStoreRef } from './store.utils';

const useInjectReducerAndSaga = (asyncReducer, asyncSaga) => {
  const reduxStore = getStoreRef();
  if (!reduxStore) return;
  if (asyncReducer) reduxStore.injectReducer(asyncReducer);
  if (asyncSaga) reduxStore.injectSaga(asyncSaga);
};

export default useInjectReducerAndSaga;
